import { render } from "./AppNavbarMenuItem.vue?vue&type=template&id=8425e4d8"
import script from "./AppNavbarMenuItem.vue?vue&type=script&lang=js"
export * from "./AppNavbarMenuItem.vue?vue&type=script&lang=js"

import "./AppNavbarMenuItem.vue?vue&type=style&index=0&id=8425e4d8&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__